<template>
    <a @click.prevent="$router.push(routerLink)" class="landing-link">
      <slot />
    </a>
  </template>
  
  <script>
  export default {
    name: "LandingPageLink",
    props: {
      routerLink: {
        type: String,
        required: true,
      },
    },
  };
  </script>
  
  <style scoped>
  .landing-link {
    font-weight: bold;
    cursor: pointer;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    transition: all 0.2s ease-in-out;
  }
  
  .landing-link:hover {
    text-decoration: underline;
  }
  </style>
  